import { getTags, createTag, updateTag, deleteTag } from '@/services/api/tag/tag'

export default {
  namespaced: true,
  state: {
    tags: [],
    loading: false,
  },
  mutations: {
    SET_TAGS(state, tags) {
      state.tags = tags
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
  },
  actions: {
    async getTags({ commit }) {
      commit('SET_LOADING', true)
      return getTags()
        .then((response) => {
          commit('SET_TAGS', response.data)
          return response.data
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => commit('SET_LOADING', false))
    },
    async updateTag({ dispatch }, tag) {
      return updateTag(tag).then(() => dispatch('getTags'))
    },
    async createTag({ dispatch }, tag) {
      return createTag(tag).then((response) => {
        dispatch('getTags')
        return response.data
      })
    },
    async deleteTag({ dispatch }, id) {
      return deleteTag(id).then(() => dispatch('getTags'))
    },
  },
  getters: {},
}
